import { render, staticRenderFns } from "./EditAccident.vue?vue&type=template&id=994542da&scoped=true&"
import script from "./EditAccident.vue?vue&type=script&lang=js&"
export * from "./EditAccident.vue?vue&type=script&lang=js&"
import style0 from "./EditAccident.vue?vue&type=style&index=0&id=994542da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994542da",
  null
  
)

export default component.exports